import EventManager from '../EventManager'

export function setUpGlobalListeners() {
  try {
    // @ts-ignore
    const observer = new ReportingObserver(
      (reports: Array<IReportingObserverReport>, observer) => {
        reports.forEach((report: IReportingObserverReport) =>
          EventManager.trigger(EventManager.events.heavyAdRemoved, report)
        )
      },
      {
        buffered: true
      }
    )

    window.addEventListener('pagehide', (event) => {
      // pull all pending reports from the queue
      const reports: Array<IReportingObserverReport> = observer.takeRecords()
      reports.forEach((report) =>
        EventManager.trigger(EventManager.events.heavyAdRemoved, report)
      )
    })
  } catch (e) {
    // no op
  }
}

export interface IReportingObserverReport {
  type: string
  url: string
  body: {
    sourceFile: string | null
    lineNumber: number | null
    columnNumber: number | null
    id: string
    message: string
  }
}
